module.exports = __webpack_public_path__ + "static/media/logo-black.1a780271.svg";